export const setTwoColLeftClass = (ratio = '', columnSize = ''): string => {
  const retValue =
    'Grid gridAlignment u-sm-sizeFull u-md-sizeFull u-sm-paddingBottom0 u-sm-marginBottom0'

  if (columnSize && columnSize === 'customConstrainedLeft') {
    if (ratio && ratio === '5050') {
      return (
        retValue +
        ' u-md-sizeFull u-paddingRight64 u-paddingTop64 u-sm-paddingRight0 u-md-paddingRight0 u-paddingVert0 '
      )
    }
  }

  if (columnSize && columnSize === 'customConstrainedRight') {
    return retValue + ' u-sm-paddingTop20 u-md-paddingTop20 u-sm-paddingRight0 u-md-paddingRight0 '
  }

  return retValue + ' u-paddingRight16 u-sm-paddingRight0 u-md-paddingRight0 '
}

export const setTwoColRightClass = (ratio = ''): string => {
  const retValue =
    'Grid gridAlignment u-sm-sizeFull u-md-sizeFull u-sm-marginLeft0 u-md-marginLeft0 '
  if (ratio && ratio === '4060') {
    return (
      retValue +
      ' u-md-sizeFull u-paddingLeft64  u-sm-paddingLeft0 u-md-paddingLeft0 u-paddingTop64 u-paddingVert0 '
    )
  }
  return retValue
}

export const setTwoColParentClass = (ratio = '', columnSize = ''): string => {
  const retValue =
    'TwoColumn Grid Grid--equalHeight  u-sm-flexWrap u-md-flexWrap  u-md-paddingHoriz20 u-sm-paddingTop48 u-md-paddingTop48'
  if (ratio && columnSize) {
    if (ratio === '4060' && columnSize === 'customConstrainedRight') {
      return retValue + ' u-heightFull u-sm-paddingBottom64 u-md-paddingBottom64'
    }
    if (ratio !== '4060') {
      if (columnSize === 'customConstrainedLeft') {
        if (ratio === '5050') {
          return (
            retValue + ' u-heightFull u-md-paddingHoriz0 u-sm-flexColReverse u-md-flexColReverse '
          )
        } else {
          return retValue + ' u-md-paddingHoriz0 u-paddingTop32 '
        }
      }
    }
    return retValue + ' u-md-paddingHoriz0 '
  }
  return retValue
}

export const setTwoColClass = (column: string, ratio = ''): string => {
  let columnClass
  switch (ratio) {
    case '4060':
      columnClass = {
        left: 'u-size4of10 u-sm-sizeFull',
        right: 'u-size6of10 u-sm-sizeFull',
      }
      break
    case '7525':
      columnClass = {
        left: 'u-size3of4 u-sm-sizeFull',
        right: 'u-size1of4 u-sm-sizeFull',
      }
      break
    case '2575':
      columnClass = {
        left: 'u-size1of4 u-sm-sizeFull',
        right: 'u-size3of4 u-sm-sizeFull',
      }
      break
    case '3366':
      columnClass = {
        left: 'u-size1of3 u-sm-sizeFull',
        right: 'u-size2of3 u-sm-sizeFull',
      }
      break
    case '6633':
      columnClass = {
        left: 'u-size2of3 u-sm-sizeFull',
        right: 'u-size1of3 u-sm-sizeFull',
      }
      break
    case 'Custom':
      columnClass = {
        left: 'u-size2of12 u-sm-sizeFull',
        right: 'u-size10of12 u-sm-sizeFull',
      }
      break
    default:
      columnClass = {
        left: 'u-size1of2 u-sm-sizeFull',
        right: 'u-size1of2 u-sm-sizeFull',
      }
      break
  }
  return columnClass[column] ?? ''
}
export const setTwoColClassGrid = (ratio = ''): string => {
  switch (ratio) {
    case '4060':
      return 'TwoColumnWrapper--4060'
    case '7525':
      return 'TwoColumnWrapper--7525'
    case '2575':
      return 'TwoColumnWrapper--2575'
    case '3366':
      return 'TwoColumnWrapper--3366'
    case '6633':
      return 'TwoColumnWrapper--6633'
    case '3070':
      return 'TwoColumnWrapper--3070'
    case 'Custom':
      return 'TwoColumnWrapper--1684'
    default:
      return ''
  }
}
